module.exports = __webpack_public_path__ + "img/tpd.27273068.png";